module.exports = __webpack_public_path__ + "img/design-image1.885db84e.png";